import { type ComponentProps } from "react";

import { motion } from "motion/react";

import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
} & ComponentProps<typeof motion.svg>;

const spinTransition = {
  duration: 0.9,
  ease: "linear" as const,
  repeat: Infinity,
};

const animate = { rotate: 360 };

export const Spinner = ({ className, ...props }: Props) => {
  return (
    <motion.svg
      animate={animate}
      className={cn(
        "stroke-azure dark:stroke-azure text-primaryBlack size-5",
        className
      )}
      fill="none"
      transition={spinTransition}
      viewBox="0 0 14 15"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 7.67725C13 8.46518 12.8448 9.24539 12.5433 9.97335C12.2417 10.7013 11.7998 11.3627 11.2426 11.9199C10.6855 12.477 10.0241 12.919 9.2961 13.2205C8.56815 13.5221 7.78793 13.6772 7 13.6772C6.21207 13.6772 5.43185 13.5221 4.7039 13.2205C3.97595 12.919 3.31451 12.477 2.75736 11.9199C2.20021 11.3627 1.75825 10.7013 1.45672 9.97335C1.15519 9.24539 1 8.46518 1 7.67725C1 6.88931 1.15519 6.1091 1.45672 5.38114C1.75825 4.65319 2.20021 3.99176 2.75736 3.4346C3.31451 2.87745 3.97595 2.4355 4.7039 2.13397C5.43185 1.83244 6.21207 1.67725 7 1.67725C7.78793 1.67725 8.56815 1.83244 9.2961 2.13397C10.0241 2.4355 10.6855 2.87745 11.2426 3.43461C11.7998 3.99176 12.2417 4.65319 12.5433 5.38115C12.8448 6.1091 13 6.88932 13 7.67725L13 7.67725Z"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M13 7.67725C13 8.62101 12.7774 9.55146 12.3502 10.393C11.923 11.2346 11.3034 11.9635 10.5415 12.5205C9.77971 13.0776 8.89723 13.4471 7.96577 13.599C7.03432 13.7509 6.08016 13.681 5.18082 13.3948C4.28148 13.1087 3.46233 12.6144 2.78991 11.9522C2.11749 11.29 1.61076 10.4785 1.31091 9.5836C1.01105 8.68874 0.926511 7.73577 1.06417 6.8021C1.20182 5.86843 1.55778 4.9804 2.10314 4.21015"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </motion.svg>
  );
};
